/**
 * 판매단위(ProductPrice) 사용기간 표시 — 주문 상세 등 GET /order/detail 품목 보강용
 */
export function formatProductPriceValidityLabel(
	validityPeriod: number | null | undefined,
	validityPeriodUnit?: string | null
): string {
	if (validityPeriod == null || !Number.isFinite(Number(validityPeriod))) {
		return '제한없음';
	}
	const n = Math.floor(Number(validityPeriod));
	if (n <= 0) return '제한없음';
	const u = String(validityPeriodUnit ?? 'MONTH').toUpperCase();
	if (u === 'DAY' || u === 'D' || u === 'DAYS') return `${n}일`;
	if (u === 'YEAR' || u === 'Y' || u === 'YEARS') return `${n}년`;
	return `${n}개월`;
}
